<div class="poc-dialog">

  <button type="button" class="poc-dialog__close" (click)="cancel()">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="poc-dialog__icon">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </div>

  <h2 class="poc-dialog__title">{{ data.title }}</h2>
  <p class="poc-dialog__message">{{ data.message }}</p>

  <div class="poc-dialog__actions">
    <button type="button" class="rp-button rp-outlined rp-primary rp-small" (click)="cancel()">Cancel</button>
    <button type="button" class="rp-button rp-filled rp-primary rp-small" (click)="confirm()">{{ data.confirmLabel }}</button>
  </div>

</div>
